import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import styles from './AutoReplyEditButtons.module.css';
import AutoReplyDeleteWarning from '../AutoReplyDeleteWarning/AutoReplyDeleteWarning';
import AddAutoReplyWindow from '../AddAutoReplyWindow/AddAutoReplyWindow';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const AutoReplyEditButtons = observer(function AutoReplyEditButtons(props) {
  const { t } = useTranslation();

  const { data } = props;
  const deleteButtonRef = React.useRef(null);
  const [selectedDeleteButton, setSelectedDeleteButton] = React.useState(null);

  const [addAwayMessageButton, setAddAwayMessageButton] = React.useState(null);

  const toggleEditItem = (e) => {
    setAddAwayMessageButton(e.currentTarget);
  };

  const closeDeleteConfirmWarning = () => {
    if (selectedDeleteButton) {
      setSelectedDeleteButton(null);
    }
  };

  const confirmDeleteItem = () => {
    setSelectedDeleteButton(deleteButtonRef.current);
  };

  const closeAddCustomAwayMessageWindow = () => {
    if (addAwayMessageButton) {
      setAddAwayMessageButton(null);
    }
  };

  return (
    <>
      <button
        type="button"
        className={[styles.optionsBtn, styles.editIconBtn].join(' ')}
        onClick={toggleEditItem}
        data-testid="editIconBtn"
      />
      <button
        ref={deleteButtonRef}
        type="button"
        className={[styles.optionsBtn, styles.deleteIconBtn].join(' ')}
        onClick={confirmDeleteItem}
        data-testid="deleteIconBtn"
      />
      <AutoReplyDeleteWarning
        data={data}
        onClose={closeDeleteConfirmWarning}
        selectedDeleteButton={selectedDeleteButton}
      />
      {addAwayMessageButton ? (
        <AddAutoReplyWindow
          title={t('CustomAwayMessages.EditCustomMessage')}
          data={data}
          button={addAwayMessageButton}
          onClose={closeAddCustomAwayMessageWindow}
          arrowDirection="bottom-end"
          autoReplyType={data.AutoReplyType}
        />
      ) : null}
    </>
  );
});
AutoReplyEditButtons.whyDidYouRender = true;
AutoReplyEditButtons.displayName = 'AutoReplyEditButtons';

export default AutoReplyEditButtons;
